// Clinic Configuration for The Rim Dental Care
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "The Rim Dental Care",
  clinicId: "therimdentalcare",
  clinicUrl: "https://therimdentalcare.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=therimdentalcare&agentId=3c859c53-6334-4075-bee4-d8828d6c1717",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/therimdentalcare/voice",

  // Contact Information
  phoneNumber: "7262159920",
  phoneNumberRaw: "+17262159920", // For tel: and sms: links
  email: "Dentist@therimdentalcare.com",

  // Location
  address: "6028 WORTH PKWY STE 101, SAN ANTONIO, TX 78257-5071, United States",
  addressShort: "6028 WORTH PKWY STE 101, SAN ANTONIO, TX 78257-5071",
  city: "SAN ANTONIO",
  hcity: "SAN-ANTONIO",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "78257-5071",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/3eqkak8tiY9o6Fnx8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13188.25925665284!2d-98.602123!3d29.612614!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c6424bb82fd9b%3A0xe9b342b0efb691bb!2sThe%20Rim%20Dental%20Care!5e1!3m2!1sen!2sin!4v1756791378261!5m2!1sen!2sin',
  iframeTitle: "The Rim Dental Care",

  //membership
  membership: "https://member.kleer.com/?slug=QC6M",

  // Sunbit
  sunbitUrl: "https://therimdentalcare.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-san-antonio---rim-dental?utm_source=practice&utm_medium=email&m=66578",


  // Analytics
  clarityProjectId: "prdn6xu3rx",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/therimdentalcare",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/therimdentalcare",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/therimdentalcare",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://therimdentalcare.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/rimdentalcare",
    instagram: "https://www.instagram.com/stories/rimdentalcare/",
    twitter: "https://x.com/RimDentalCare",
    linkedin: "https://www.linkedin.com/company/the-rim-dentalcare/",
    youtube: "https://www.youtube.com/@rimdentalcare",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 8
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 3
    }
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
